var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("node-view-wrapper", { staticClass: "mail-tag-wrapper" }, [
    _c(
      "span",
      {
        staticClass: "mail-tag",
        class: { "invalid-mail": !_vm.node.attrs.valid },
        attrs: { contenteditable: "false" },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        !_vm.node.attrs.valid
          ? _c("a-tooltip", { attrs: { title: "Geçersiz e-posta formatı" } }, [
              _c("span", { staticClass: "mail-content" }, [
                _vm._v(_vm._s(_vm.node.attrs.mail)),
              ]),
            ])
          : _c("span", { staticClass: "mail-content" }, [
              _vm._v(_vm._s(_vm.node.attrs.mail)),
            ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "remove-tag", on: { click: _vm.deleteNode } },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }